import { slackService } from "@/services";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { qk } from "./queryKeys";

export function useSlackConnection() {
	return useQuery({
		queryKey: qk.slack,
		queryFn: ({ signal }) => slackService.getConnection(signal),
	});
}

export function useSlackMutations() {
	const qc = useQueryClient();
	return {
		connect: useMutation({ mutationFn: slackService.startConnection }),
		disconnect: useMutation({
			mutationFn: slackService.disconnect,
			onSuccess: () => qc.invalidateQueries({ queryKey: qk.slack }),
		}),
	};
}
